// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import EventsScrollerController from "./events_scroller_controller"
application.register("events-scroller", EventsScrollerController)

import NavbarShrinkController from "./navbar_shrink_controller"
application.register("navbar-shrink", NavbarShrinkController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import AccountTypeToggleController from "./account_type_toggle_controller"
application.register("account-type-toggle", AccountTypeToggleController)

import AccountSidebarController from "./account_sidebar_controller"
application.register("account-sidebar", AccountSidebarController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import CourseSessionsController from "./course_sessions_controller"
application.register("course-sessions", CourseSessionsController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import CheckoutParticipantsController from "./checkout_participants_controller"
application.register("checkout-participants", CheckoutParticipantsController)

import ShareController from "./share_controller"
application.register("share", ShareController)
